<template>
    <b-modal
        v-model="isSale"
        centered
        hide-backdrop content-class="shadow"
        :hide-footer="true"
        :hide-header="true"
        >
        <div class="d-flex flex-column justify-content-center align-items-center">
            <div class="check-icon">
                <svg  width="100%" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M131.045 52.2949L138.955 60.2051L73.125 126.035L41.0449 93.9551L48.9551 86.0449L73.125 110.215L131.045 52.2949ZM90 0C98.2617 0 106.23 1.05469 113.906 3.16406C121.582 5.27344 128.76 8.29102 135.439 12.2168C142.119 16.1426 148.184 20.8301 153.633 26.2793C159.082 31.7285 163.77 37.8223 167.695 44.5605C171.621 51.2988 174.639 58.4766 176.748 66.0938C178.857 73.7109 179.941 81.6797 180 90C180 98.2617 178.945 106.23 176.836 113.906C174.727 121.582 171.709 128.76 167.783 135.439C163.857 142.119 159.17 148.184 153.721 153.633C148.271 159.082 142.178 163.77 135.439 167.695C128.701 171.621 121.523 174.639 113.906 176.748C106.289 178.857 98.3203 179.941 90 180C81.7383 180 73.7695 178.945 66.0938 176.836C58.418 174.727 51.2402 171.709 44.5605 167.783C37.8809 163.857 31.8164 159.17 26.3672 153.721C20.918 148.271 16.2305 142.178 12.3047 135.439C8.37891 128.701 5.36133 121.553 3.25195 113.994C1.14258 106.436 0.0585938 98.4375 0 90C0 81.7383 1.05469 73.7695 3.16406 66.0938C5.27344 58.418 8.29102 51.2402 12.2168 44.5605C16.1426 37.8809 20.8301 31.8164 26.2793 26.3672C31.7285 20.918 37.8223 16.2305 44.5605 12.3047C51.2988 8.37891 58.4473 5.36133 66.0059 3.25195C73.5645 1.14258 81.5625 0.0585938 90 0ZM90 168.75C97.207 168.75 104.15 167.812 110.83 165.938C117.51 164.062 123.779 161.426 129.639 158.027C135.498 154.629 140.83 150.498 145.635 145.635C150.439 140.771 154.541 135.469 157.939 129.727C161.338 123.984 164.004 117.715 165.938 110.918C167.871 104.121 168.809 97.1484 168.75 90C168.75 82.793 167.812 75.8496 165.938 69.1699C164.062 62.4902 161.426 56.2207 158.027 50.3613C154.629 44.502 150.498 39.1699 145.635 34.3652C140.771 29.5605 135.469 25.459 129.727 22.0605C123.984 18.6621 117.715 15.9961 110.918 14.0625C104.121 12.1289 97.1484 11.1914 90 11.25C82.793 11.25 75.8496 12.1875 69.1699 14.0625C62.4902 15.9375 56.2207 18.5742 50.3613 21.9727C44.502 25.3711 39.1699 29.502 34.3652 34.3652C29.5605 39.2285 25.459 44.5312 22.0605 50.2734C18.6621 56.0156 15.9961 62.2852 14.0625 69.082C12.1289 75.8789 11.1914 82.8516 11.25 90C11.25 97.207 12.1875 104.15 14.0625 110.83C15.9375 117.51 18.5742 123.779 21.9727 129.639C25.3711 135.498 29.502 140.83 34.3652 145.635C39.2285 150.439 44.5312 154.541 50.2734 157.939C56.0156 161.338 62.2852 164.004 69.082 165.938C75.8789 167.871 82.8516 168.809 90 168.75Z" fill="#136DF6"/>
                </svg>
            </div>
            <h2 class="fs-26"><strong>THANK YOU!</strong></h2>
            <p class="fs-26">Transaction successful.</p>
            <div class="d-flex justify-content-center mt-4 mb-4">
                <div v-if="sale.transactionAmount > 0" class="text-center" :class='{ "border-right border-primary pr-4" : sale.isCash }'>
                    <h2 class="fs-34 mb-3"><strong>${{ sale.transactionAmount.toFixed(2) }}</strong></h2>
                    <h5>Total Paid</h5>
                </div>
                <div v-if ="sale.isCash" class="text-center" :class='{"pl-4": sale.transactionAmount > 0 }'>
                    <h2 class="fs-34 mb-3"><strong>${{ sale.changeTenderAmount.toFixed(2) }}</strong></h2>
                    <h5>Change</h5>
                </div>
            </div>
        </div>

    </b-modal>
</template>
<script>
export default {
  props: {
    isSale: {
      type: Boolean,
      default: false
    },
    sale: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    openDialog: true
  })
}
</script>
<style scoped>

.check-icon{
    width:100px;
}
.fs-26{
    font-size: 26px;
    font-weight: 400;
}

.fs-34{
    font-size: 34px;
    font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/TransactionModal.vue